<template>
  <div class="flex min-h-0 min-w-0 flex-1 flex-col">
    <div class="mb-2 flex items-baseline justify-between">
      <div class="text-base-content/80 mb-2 text-xl font-bold">
        Lịch sử chạy LoLBin
      </div>
      <CreateLolBin />
    </div>
    <div class="mt-4">
      <Loading v-if="action_store.loading.get_action_history" />
      <template v-else-if="action_store.total_filter > 0">
        <table class="table-pin-rows table-md mb-4 table">
          <thead>
            <tr>
              <th>Công cụ</th>
              <th>Thời gian tạo</th>
              <th>URL</th>
              <th>Trạng thái</th>
            </tr>
          </thead>
          <tbody class="bg-base-200">
            <tr v-for="action in action_store.actions" :key="action.id">
              <td>
                <div class="kbd">{{ action.run_with }}</div>
              </td>
              <td>{{ dayjs(action.created).fromNow() }}</td>
              <td class="break-all">{{ action.args }}</td>
              <td><ActionStatus :status="action.status" /></td>
            </tr>
          </tbody>
        </table>
        <PaginationTemplate :total_pages="action_store.total_pages" />
      </template>
      <NotFound v-else />
    </div>
  </div>
</template>

<script setup lang="ts">
import dayjs from "dayjs";
import Loading from "@/components/LoadingTemplate.vue";
import NotFound from "@/components/NotFound.vue";
import PaginationTemplate from "@/components/PaginationTemplate.vue";
import ActionStatus from "../ExplorerV2/ActionStatus.vue";
import { use_action } from "../ExplorerV2/useAction";
import CreateLolBin from "./CreateLolBin.vue";

const action_store = use_action();
void action_store.get_action_history({ type: "lol_bin" });
</script>
